import React from 'react';
import { getUsdtPayoutOrders, formatNumbers } from '../../utils/helpers';
import { useTranslation } from 'react-i18next';

const OpenOrderList = ({ userId, openOrders, CancelingPoolOrders, tokenSymbol }) => {
    const { t } = useTranslation();
    return (
        <>
            {openOrders && openOrders.length > 0 ? (
                openOrders?.filter(order => order.user === userId)?.map((order) =>
                (
                    <>
                        <div key={order.externalID} className="openorderlist">
                            <div className="single-list">
                                <p>{t('Option')}</p>
                                <h6>
                                    {order.optionDetail.optionName}
                                </h6>
                            </div>
                            <div className="single-list">
                                <p>{t('Opened at')}</p>
                                <h6>{new Date(order.createdAt)?.toLocaleString()}</h6>
                            </div>
                            <div className="single-list">
                                <p>{t('Type')}</p>
                                <h6 className={order.orderType === 'sell' ? 'sell-color' : 'buy-color'}>{order.orderType}</h6>
                            </div>
                            <div className="single-list">
                                <p>{t('Price per share')}</p>
                                <h6>{Number(order.pricePerShare).toFixed(2)} {tokenSymbol}</h6>
                            </div>
                            <div className="single-list">
                                <p>{t('Shares')}</p>
                                <h6>{formatNumbers(+(order.quantity))}</h6>
                            </div>
                            <div className="single-list">
                                <p>{t(`${tokenSymbol} you get`)}</p>
                                <h6>{formatNumbers(getUsdtPayoutOrders(order.pricePerShare, order.quantity))} {tokenSymbol}</h6>
                            </div>
                            {/* <div className="single-list">
                                <p>Filled Size</p>
                                <h6>0/{order.quantity} (0.00%)</h6>
                            </div> */}
                            <div className="single-list">
                                <a
                                    className="btn-cancel"
                                    onClick={() =>
                                        CancelingPoolOrders({
                                            optionNumber: order.orderOption,
                                            PriceofShares: order.pricePerShare,
                                            OrderId: order.externalID,
                                            orderType: order.orderType,

                                        })
                                    }
                                >
                                    {t('Cancel')}
                                </a>
                            </div>
                        </div >
                    </>
                ))
            ) : (
                <p className="text-white">{t('No open orders found')}</p>
            )}
        </>
    );
};

export default OpenOrderList;